import React, { useEffect, useState } from 'react';
import introJs from "intro.js";
import 'intro.js/introjs.css'; 
import { useNavigate } from 'react-router-dom';

const AccountTutorial = (props) => {
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Delay tutorial start until elements are in the DOM
    const checkElements = setInterval(() => {
      if (document.querySelector(".account1")) {
        setIsReady(true);
        clearInterval(checkElements);
      }
    }, 200);

    return () => clearInterval(checkElements); // Cleanup
  }, []);

  useEffect(() => {
    if (!isReady) return;

    const intro = introJs();

    intro.setOptions({
      steps: [
        {
          element: ".account1",
          intro: "به حرف به حرف خوش آمدید :) لطفاً اطلاعات کاربری تان را تکمیل کنید",
        },
      ],
      showBullets: false,
      position: "top",
      showProgress: true,
      exitOnOverlayClick: false,
      disableInteraction: false,
      highlightClass: "introjs-highlight-circle",
      nextLabel: "بعدی",
      prevLabel: "قبلی",
      doneLabel: " تکمیل  کردم 🎉",
    });

    const handleExit = async () => {
      await props.SaveAccountTutorialSeen(true)
      navigate("/dashboard");
    };

    intro.oncomplete(handleExit);
    intro.onexit(handleExit);

    intro.start();

    return () => intro.exit();
  }, [isReady, navigate]);

  return <div></div>;
};

export default AccountTutorial;
